import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import BonTransfert from "../TransfertArticles/files/BonTransfert";
import ListArticleDefectueux from "../ArticleDefectueux/ListArticleDefectueux";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  selectUser,
  selectUserId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { updateArticleDefectueux } from "../../_App/Redux/Slices/articledefectueux/articledefectueuxSlice";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { ListOrganisations } from "../../_App/Redux/Slices/organisations/organisationSlice";
import { calculTotal } from "../../_App/Helpers/helpers";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { CorrectIncidentApi } from "../../_App/Redux/Slices/incident/incidentSlice";

export default function TransfertAnnomalie({
  societe_id,
  showModal,
  setshowModal,
  annomalie,
  t,
}: any) {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const listOragnisation = useAppSelector(ListOrganisations);
  const [list, setList] = useState<any>([]);
  const tableRef = useRef<HTMLTableElement>(null);

  useEffect(() => {
    setList(annomalie?.annomalie?.data);
  }, [annomalie?.annomalie?.data]);
  // Ligne en correction
  const [correction, setCorrection] = useState<{ index: number | null }>({
    index: null,
  });
  const [corrections, setCorrections] = useState<any>(null); // { item, qteEnvAvant, qteEnvCorrect, qteRecAvant, qteRecCorrect }

  const [showbon, setshowbon] = useState(false);
  const [showRemise, setshowRemise] = useState(false);

  // Ouvre une ligne pour correction
  const startCorrection = (index: number) => {
    if (correction.index !== null && correction.index !== index) {
      cancelCorrection();
    }

    const item = annomalie.annomalie.data[index];

    setCorrections({
      item,
      qteEnvAvant: item.Quantiteenvoyee || item.stk_before_inventaire || 0,
      qteRecAvant: item.QuantitReception || item.stk_after_inventaire || 0,
    });

    setCorrection({ index });
  };

  // Annule la correction
  const cancelCorrection = () => {
    setCorrections(null);
    setCorrection({ index: null });
  };

  // Valide la correction et appelle l'API
  const validerCorrection = async () => {
    if (!corrections) return;

    // Utilisation d'un bloc try/catch si dispatch peut rejeter,
    // sinon l'approche payload.success est standard avec createAsyncThunk
    const resp = await dispatch(
      CorrectIncidentApi({ corrections, annomalie, user }),
    );

    if (resp.payload?.success) {
      const resIncident = resp.payload.data;
      // On récupère l'ID cible de manière sécurisée
      const targetId =
        annomalie?.action === "Inventaire"
          ? resIncident?.article?._id?.toString()
          : resIncident?.article_id?._id?.toString();

          console.log('targetId',targetId)
      const updatedList = list.map((item: any) => {
        // On récupère l'ID de l'item actuel de manière flexible
        const currentId = annomalie?.action === "Inventaire"
          ? resIncident?.article?._id?.toString()
          : resIncident?.article_id?._id?.toString();


        // DEBUG: Décommente la ligne suivante si ça ne marche toujours pas
        // console.log(`Comparaison: currentId ${currentId} vs targetId ${targetId}`);

        if (!currentId || currentId !== targetId) {
          return item;
        }

        // Si on arrive ici, c'est que c'est le bon élément
        if (annomalie?.action === "inventaire") {
          return {
            ...item,
            stk_after_inventaire_corrected:
              resIncident?.stk_after_inventaire_corrected,
            corrected: resIncident?.corrected,
            correctedBy: resIncident?.correctedBy,
          };
        }

        return resIncident;
      });

      setList(updatedList);

      setList(updatedList);

      // Reset et Feedback
      ToastSuccess(t(resp.payload.message));
      setCorrection({ index: null });
      setCorrections(null);
    } else {
      ToastWarning(t(resp.payload.message || "Une erreur est survenue"));
    }
  };

  const handlePrintPDF = () => {
    if (!list) return;
    const doc = new jsPDF();
    const columns: any[] = [
      { header: t("Article"), dataKey: "article" },
      { header: t("Code Article"), dataKey: "code" },
    ];

    const a = annomalie?.annomalie;

    if (annomalie.action === "Article defecteuxes") {
      columns.push({ header: t("Quantité"), dataKey: "quantite" });
    } else {
      columns.push(
        {
          header: `${t("Quantité Envoyée")} (${calculTotal(
            a?.data,
            "Quantiteenvoyee",
            "stk_before_inventaire",
          )})`,
          dataKey: "qteEnv",
        },
        {
          header: `${t("Quantité Réception")} (${calculTotal(
            a?.data,
            "QuantitReception",
            "stk_after_inventaire",
          )})`,
          dataKey: "qteRec",
        },
      );
    }

    const data = annomalie.annomalie.data.map((item: any) => ({
      article: item.article_id?.titre?.fr || item.article?.titre?.fr,
      code: item.article_id?.code_article || item.article?.code_article,
      quantite: item.Quantite || 0,
      qteEnv: item.Quantiteenvoyee || item.stk_before_inventaire || 0,
      qteRec: item.QuantitReception || item.stk_after_inventaire || 0,
    }));

    doc.text(t("Liste des annomalies"), 17, 15);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    const texte =
      t(`annomalie ${annomalie?.action} N° `) +
      " " +
      (annomalie.action === "Inventaire"
        ? `${annomalie?.Objet?.code_inventaire} - Titre: ${annomalie?.Objet?.titre}`
        : annomalie.action === "Transfert"
        ? annomalie?.Objet?.NumBonreception
        : annomalie?.Objet?.codeabarre);

    doc.text(texte, 14, 20);

    autoTable(doc, {
      head: [columns.map((col) => col.header)],
      body: data.map((row: any) => columns.map((col) => row[col.dataKey])),
      styles: { fontSize: 10, cellPadding: 3 },
      headStyles: { fillColor: [224, 224, 224], fontStyle: "bold" },
      startY: 25,
    });

    window.open(doc.output("bloburl"), "_blank");
  };

  const updateArticle_Defectueux = async (data: any) => {
    const resp = await dispatch(
      updateArticleDefectueux({ data, user: user?._id }),
    );
    if (resp && resp.payload.success) {
      ToastSuccess(t(resp.payload.message));
      window.location.reload();
    } else {
      ToastWarning(resp.payload.message);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setshowModal(false)}
      style={{ display: "flex", justifyContent: "center" }}
      dialogClassName="modal-90w"
    >
      <Modal.Header>
        {t(`annomalie ${annomalie.action} N° `)}
        {annomalie.action === "Inventaire"
          ? annomalie?.Objet?.code_inventaire +
            "- Titre: " +
            annomalie?.Objet?.titre
          : annomalie.action === "Transfert"
          ? annomalie?.Objet?.NumBonreception
          : annomalie?.Objet?.codeabarre}

        {annomalie.action === "Transfert" && (
          <span
            className="btn-primary-app pointer"
            onClick={() => setshowbon(true)}
          >
            <i className="fas fa-file-powerpoint"></i>
            <p>{t("Voir bon réception")}</p>
          </span>
        )}

        {annomalie.action === "Article defecteuxes" && (
          <button
            onClick={() => setshowRemise(!showRemise)}
            className="btn btn-primary"
          >
            {showRemise ? t("Annuler remise") : t("Ajouter remise")}
          </button>
        )}
      </Modal.Header>

      <Modal.Body>
        {t("MESSAGE :")} {annomalie?.annomalie?.msg}
        <br />
        {t("Liste des annomalies")}
        <table
          ref={tableRef}
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  backgroundColor: "#e0e0e0",
                  textAlign: "left",
                }}
              >
                {t("Article")}
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  backgroundColor: "#e0e0e0",
                  textAlign: "left",
                }}
              >
                {t("Code Article")}
              </th>
              {annomalie.action !== "Article defecteuxes" && (
                <>
                  <th
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      backgroundColor: "#e0e0e0",
                      textAlign: "left",
                    }}
                  >
                    {annomalie.action === "Transfert"
                      ? t("Quantité Envoyée")
                      : t("Quantité Calculée")}
                  </th>
                  <th
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      backgroundColor: "#e0e0e0",
                      textAlign: "left",
                    }}
                  >
                    {annomalie.action === "Transfert"
                      ? t("Quantité Réception")
                      : t("Quantité Entrée")}
                  </th>
                  <th
                    style={{
                      border: "1px solid #000",
                      padding: "8px",
                      backgroundColor: "#e0e0e0",
                      textAlign: "center",
                    }}
                  >
                    {t("Correction")}
                  </th>
                </>
              )}
            </tr>
          </thead>

          <tbody>
            {list?.map((item: any, i: number) => (
              <tr key={i}>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                  }}
                >
                  {item.article_id?.titre?.fr || item.article?.titre?.fr}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "8px",
                    textAlign: "left",
                  }}
                >
                  {item.article_id?.code_article || item.article?.code_article}
                </td>

                {annomalie.action !== "Article defecteuxes" && (
                  <>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      {correction.index === i ? (
                        <div>
                          <div style={{ fontSize: "12px", color: "gray" }}>
                            {t("Ancien")}:{" "}
                            <strong>{corrections.qteEnvAvant}</strong>
                          </div>
                          <input
                            type="number"
                            min={0}
                            value={corrections.qteEnvCorrect}
                            onChange={(e) =>
                              setCorrections({
                                ...corrections,
                                qteEnvCorrect: Number(e.target.value),
                              })
                            }
                            readOnly={annomalie.action === "Inventaire"}
                            className="form-control"
                            style={{ marginTop: "5px" }}
                          />
                        </div>
                      ) : (
                        <>
                          {item.Quantiteenvoyee ||
                            item.stk_before_inventaire ||
                            0}

                          {/* valeur corrigée si corrected == true */}
                          {item.corrected && item.qteEnvCorrect && (
                            <div style={{ fontSize: "12px", color: "gray" }}>
                              {t("Qte Correction")}:{" "}
                              <strong>{item.qteEnvCorrect}</strong>
                            </div>
                          )}
                        </>
                      )}
                    </td>

                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      {correction.index === i ? (
                        <div>
                          <div style={{ fontSize: "12px", color: "gray" }}>
                            {t("Ancien")}:{" "}
                            <strong>{corrections.qteRecAvant}</strong>
                          </div>
                          <input
                            type="number"
                            min={0}
                            value={corrections.qteRecCorrect}
                            onChange={(e) =>
                              setCorrections({
                                ...corrections,
                                qteRecCorrect: Number(e.target.value),
                              })
                            }
                            className="form-control"
                            style={{ marginTop: "5px" }}
                          />
                        </div>
                      ) : (
                        <>
                          {item.QuantitReception ||
                            item.stk_after_inventaire ||
                            0}

                          {(item.corrected && item.qteRecCorrect) ||
                            (item.stk_after_inventaire_corrected && (
                              <div style={{ fontSize: "12px", color: "gray" }}>
                                {t("Qte Correction")}:{" "}
                                <strong>
                                  {item.stk_after_inventaire_corrected}
                                </strong>
                              </div>
                            ))}
                        </>
                      )}
                    </td>

                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      {correction.index === i ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="btn btn-success btn-sm"
                            onClick={validerCorrection}
                          >
                            {t("Valider")}
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={cancelCorrection}
                          >
                            {t("Annuler")}
                          </button>
                        </div>
                      ) : item.corrected ? (
                        <p>
                          {" "}
                          deja coriger par{" "}
                          {item?.correctedBy?.nom +
                            " " +
                            item?.correctedBy?.prenom}
                        </p>
                      ) : (
                        <button
                          className="btn btn-warning btn-sm"
                          onClick={() => startCorrection(i)}
                        >
                          {t("Corriger")}
                        </button>
                      )}
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        {showRemise && (
          <ListArticleDefectueux
            t={t}
            listOragnisation={listOragnisation}
            listdefectueux={[annomalie.Objet]}
            organisationId={annomalie.Objet.organisation_id}
            user_id={user?._id}
            societe_id={annomalie.Objet.societe_id}
            TicketItem={() => {}}
            updateArticle_Defectueux={updateArticle_Defectueux}
          />
        )}
        {showbon && (
          <BonTransfert
            societeid={societe_id}
            datainfo={annomalie?.transfert_id}
            type="reception"
            setshowbon={setshowbon}
            ShowBon={showbon}
            t={t}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-secondary" onClick={handlePrintPDF}>
          {t("Imprimer le tableau (PDF)")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
